<template>
  <v-container v-if="club">
      <v-row
        no-gutters
      >
      </v-row>
    </v-container>
  <v-table density="compact">
    <thead>
      <tr>
        <th class="text-center">
          Nombre
        </th>
        <th class="text-center">
          Cantidad Inscritos
        </th>
        <th class="text-center">
          Solicitud Entradas
        </th>
        <th class="text-center">
          Solicitud Salidas
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="c in club"
        :key="c.id"
      >
        <td class="text-left" style="width: 800px"><a :href="'/integrantes_club/'+c.id" style="color:blue">{{ c.name }}</a></td>
        <td class="text-left">{{ c.inscriptions_count }}</td>
        <td class="text-left">{{ c.entry_count }}</td>
        <td class="text-left">{{ c.exit_count }}</td>
      </tr>
    </tbody>
  </v-table>
</template>

<script>
  import gql from "graphql-tag";
  import { vue3Debounce } from 'vue-debounce'
  import {mapState} from "vuex";
  export default {
    directives: {
    debounce: vue3Debounce({ lock: true })
  },
    apollo: {
    club: {query: gql`{
       club{
        id
        name
        inscriptions_count:inscriptionsCount
        entry_count:entryCount
        exit_count:exitCount
      }
    }`

    },
  },
    name:"ClubChess",
    data () {
      return {
        club:null,
      }
    },
    computed: {
    ...mapState(['is_authenticated']),
  },
    methods: {
      redirect(id){
        if(id){
          window.location.href = '/club/' + id
        }
      },
  },
  }
</script>

